export default /* glsl */ `vec2 mapUV(vec4 uvwo, vec4 stpq) {
  return uvwo.xy;
}
`;
